import auth from 'src/services/auth';

enum VARIANCE_COLORS {
  negative = '#DAA136',
  similar = '#9ca2a3',
  positive = '#6736da',
}

enum VARIANCE_COLORS_DARK_MODE {
  negative = '#FF9F00',
  similar = '#C4C4C4',
  positive = '#9000FF',
}

const getVarienceColors = () => {
  const themeName = auth.getSkin();

  switch (themeName) {
    case 'dark mode': {
      return VARIANCE_COLORS_DARK_MODE;
    }
    default: {
      return VARIANCE_COLORS;
    }
  }
};

//export default VARIANCE_COLORS;
export default getVarienceColors();
